<template>
  <div>
    <PictureDisplay :image-list="images" />
    <SiteFooter />
  </div>
</template>

<script>
  import PictureDisplay from '../components/PictureDisplay.vue'
  import SiteFooter from '../components/SiteFooter.vue'
  export default {
    components: { PictureDisplay, SiteFooter },
    data() {
      return {
        images: [
          // {
          //   url: require("@/assets/images/pro/焦作市广利灌区水电站设计.png"),
          //   name: "焦作市广利灌区水电站设计",
          // },
          // {
          //   url: require("@/assets/images/pro/栗子坪水电站优化运行项目.png"),
          //   name: "栗子坪水电站优化运行项目",
          // },
          {
            url: require('@/assets/images/pro/陆浑水库水电站优化调度项目.png'),
            name: '陆浑水库水电站优化调度项目'
          },
          {
            url: require('@/assets/images/pro/陆浑水库水电站增效扩容改造项目.png'),
            name: '陆浑水库水电站增效扩容改造项目'
          },
          {
            url: require('@/assets/images/pro/陆浑水资源优化配置研究—科技攻关项目.png'),
            name: '陆浑水资源优化配置研究—科技攻关项目'
          },
          {
            url: require('@/assets/images/pro/洛宁梯级水电站优化调度项目.png'),
            name: '洛宁梯级水电站优化调度项目'
          },
          {
            url: require('@/assets/images/pro/南湾水库水电站增效扩容改造项目.png'),
            name: '南湾水库水电站增效扩容改造项目'
          },
          {
            url: require('@/assets/images/pro/鲇鱼山梯级水电站优化调度项目.png'),
            name: '鲇鱼山梯级水电站优化调度项目'
          },
          {
            url: require('@/assets/images/pro/鲇鱼山梯级水电站远程故障诊断项目.png'),
            name: '鲇鱼山梯级水电站远程故障诊断项目'
          }
        ]
      }
    }
  }
</script>

<style scoped></style>
